import React from "react";
import styled from "@emotion/styled";
import Frame400 from "../../assets/images/quiz/Frame400.png";

export const ExcellentCard = ({ summaryScorePercent = 0 }) => {
  return (
    <Container>
      <div style={{ width: "100%", marginBottom: "16px" }}>
        <TrophyImg src={Frame400} />
      </div>
      <TrophyText>
        ขอแสดงความยินดี {summaryScorePercent} %{" "}
        {summaryScorePercent >= 80 && <strong>ดีมาก</strong>}
      </TrophyText>
    </Container>
  );
};

const TrophyImg = styled.img`
  width: 260px;
  height: auto;
`;

const TrophyText = styled.span`
  width: 100%;
  padding: 6px 16px;
  font-family: "Noto Sans Thai";
  font-weight: 400;
  font-size: 17px;
  background: #fc6b4b;
  border-radius: 20px;
  color: white;
`;

const Container = styled.div`
  background: linear-gradient(180deg, #fedb82 19.9%, #ff8c39 126.77%);
  border-radius: 20px;
  padding: 20px;
  display: flex column;
`;
